const Footer = () => {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/8 pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/d1351590-8cd2-45d9-bbe4-eacb238e475e/23228cbd-20e5-4c8b-8bb7-51ecf69320b6_Logo-da-Drone-Fcil.png?v=7d5630757adfff944c23036cb8ec71af"
              alt="Drone Fácil"
              className="h-10 w-auto object-contain bg-white rounded-lg px-2 py-1 mb-4"
            />
            <p className="text-white/45 text-sm leading-relaxed mb-5">
              Especialistas em imagens aéreas profissionais com drone em São Paulo. Certificados ANAC, equipamentos DJI de última geração.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-instagram-line', href: 'https://instagram.com/dronefacilsp' },
                { icon: 'ri-youtube-line', href: '#' },
                { icon: 'ri-linkedin-box-line', href: '#' },
                { icon: 'ri-whatsapp-line', href: 'https://wa.me/5511954283481' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center bg-white/8 hover:bg-[#f5a623]/20 hover:text-[#f5a623] text-white/50 rounded-lg transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 tracking-wide">Serviços</h4>
            <ul className="flex flex-col gap-3">
              {['Acompanhamento de Obras', 'Fotos para Imobiliárias', 'Cobertura de Eventos', 'Mapeamento Aéreo'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => handleNav('#servicos')}
                    className="text-white/45 hover:text-[#f5a623] text-sm transition-colors duration-200 cursor-pointer text-left whitespace-nowrap"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 tracking-wide">Empresa</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Sobre Nós', href: '#sobre' },
                { label: 'Portfólio', href: '#galeria' },
                { label: 'Contato', href: '#contato' },
                { label: 'Certificações', href: '#sobre' },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => handleNav(item.href)}
                    className="text-white/45 hover:text-[#f5a623] text-sm transition-colors duration-200 cursor-pointer text-left whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 tracking-wide">Contato Rápido</h4>
            <div className="flex flex-col gap-4">
              <a
                href="https://wa.me/5511954283481"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/45 hover:text-[#25D366] text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base"></i>
                (11) 95428-3481
              </a>
              <a
                href="mailto:dronefacilsp@gmail.com"
                className="flex items-center gap-3 text-white/45 hover:text-[#f5a623] text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-mail-line text-base"></i>
                dronefacilsp@gmail.com
              </a>
              <div className="flex items-start gap-3 text-white/45 text-sm">
                <i className="ri-map-pin-line text-base mt-0.5 flex-shrink-0"></i>
                Rua do Lago, 237<br />São Paulo, SP
              </div>
            </div>

            <a
              href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-semibold text-xs px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-sm"></i>
              Falar no WhatsApp
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Drone Fácil SP. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-2 text-white/30 text-xs">
            <i className="ri-shield-check-line text-[#f5a623] text-sm"></i>
            Operador Certificado ANAC &bull; São Paulo, Brasil
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
